import { Loader2 } from "lucide-react";

export function Loader() {
  return (
    <div className="flex h-full overflow-hidden w-full items-center justify-center">
      <Loader2 className="animate-spin size-10 mt-28" />
    </div>
  );
}
